import {
	USER_CONTACTTYPES_ERR_MSG_EMPTY,
	USER_CUSTOMERS_ERR_MSG_EMPTY,
	USER_ROLES_ERR_MSG_EMPTY,
} from 'constants/validMsg';
import * as TY from 'containers/pages/users/constants';
import validateEmail from 'libs/validations/validateEmail';
import validateFirstName from 'libs/validations/validateFirstName';
import validateLastName from 'libs/validations/validateLastName';
import validateUsername from 'libs/validations/validateUsername';
import { initValid } from '../data';

/**
 * @function checkUserValid
 * @param {User} user
 * @param {function} setValid
 * @param {boolean} ignoreUserNameError - Ignore username validation for legacy data
 * @returns {boolean} - `true` if at least one field is invalid (`canNotSave: true`), otherwise `false`
 */
function checkUserValid(user, setValid, ignoreUserNameError = false) {
	let updatedValid = { ...initValid };
	let canNotSave = false;

	const _fname = validateFirstName(user[TY.F_NAME]);
	updatedValid[TY.F_NAME] =
		_fname.isErr || user[TY.F_NAME] === ''
			? { isErr: true, errMsg: _fname.errMsg || '', canNotSave: true }
			: { isErr: false, errMsg: '', canNotSave: false };

	const _lname = validateLastName(user[TY.L_NAME]);
	updatedValid[TY.L_NAME] =
		_lname.isErr || user[TY.L_NAME] === ''
			? { isErr: true, errMsg: _lname.errMsg || '', canNotSave: true }
			: { isErr: false, errMsg: '', canNotSave: false };

	updatedValid[TY.COMPANIES] =
		user[TY.COMPANIES].length === 0
			? {
					isErr: true,
					errMsg: USER_CUSTOMERS_ERR_MSG_EMPTY,
					canNotSave: true,
			  }
			: { isErr: false, errMsg: '', canNotSave: false };

	const _emailWork = validateEmail(user[TY.EMAIL_WORK]);
	updatedValid[TY.EMAIL_WORK] = _emailWork.isErr
		? { isErr: true, errMsg: _emailWork.errMsg, canNotSave: true }
		: { isErr: false, errMsg: '', canNotSave: false };

	const _emailPersonal = validateEmail(user[TY.EMAIL_PERSONAL]);
	updatedValid[TY.EMAIL_PERSONAL] = _emailPersonal.isErr
		? { isErr: true, errMsg: _emailPersonal.errMsg, canNotSave: true }
		: { isErr: false, errMsg: '', canNotSave: false };

	const _emailOther = validateEmail(user[TY.EMAIL_OTHER]);
	updatedValid[TY.EMAIL_OTHER] = _emailOther.isErr
		? { isErr: true, errMsg: _emailOther.errMsg, canNotSave: true }
		: { isErr: false, errMsg: '', canNotSave: false };

	updatedValid[TY.CONTACT_TYPES] =
		user[TY.CONTACT_TYPES].length === 0
			? {
					isErr: true,
					errMsg: USER_CONTACTTYPES_ERR_MSG_EMPTY,
					canNotSave: true,
			  }
			: { isErr: false, errMsg: '', canNotSave: false };

	if (!ignoreUserNameError) {
		const _uname = validateUsername(user[TY.U_NAME]);
		updatedValid[TY.U_NAME] =
			_uname.isErr || user[TY.U_NAME] === ''
				? { isErr: true, errMsg: _uname.errMsg || '', canNotSave: true }
				: { isErr: false, errMsg: '', canNotSave: false };
	} else {
		updatedValid[TY.U_NAME] = {
			isErr: false,
			errMsg: '',
			canNotSave: false,
		};
	}

	updatedValid[TY.ROLES] =
		user[TY.ROLES].length === 0
			? {
					isErr: true,
					errMsg: USER_ROLES_ERR_MSG_EMPTY,
					canNotSave: true,
			  }
			: { isErr: false, errMsg: '', canNotSave: false };

	if (user.id !== '') {
		updatedValid[TY.PWD] = { isErr: false, errMsg: '', canNotSave: false };
		updatedValid[TY.CONFIRM_PWD] = {
			isErr: false,
			errMsg: '',
			canNotSave: false,
		};
	}

	// Determine if at least one field has canNotSave set to true
	canNotSave = Object.values(updatedValid).some((field) => field.canNotSave);
	setValid(updatedValid);
	return canNotSave;
}

export default checkUserValid;
